export function resolveHref(documentType: string, slug: string): string | undefined {
    switch (documentType) {
        case 'page':
        case 'link':
            return slug ? `/${slug}` : undefined
        case 'project':
            return slug ? `/our-work/${slug}` : undefined
        default:
            console.warn('Invalid document type:', documentType)
            return undefined
    }
}

type SanityLink = {
    title: string
    url: string
}

export const getSanityLink = (link: any): SanityLink | null => {
    if (!link) return null

    const { internalLink, linkType, href, title } = link

    const url = linkType === 'internal' ? resolveHref(internalLink?._type, internalLink?.slug) : href

    if (!url) return null

    if (linkType === 'internal') {
        return {
            title: title || internalLink?.title,
            url,
        }
    } else if (linkType === 'external' || href) {
        return {
            title,
            url,
        }
    }
    return null
}

export const returnDate = (
    date: string | number | Date,
    noDay: boolean = false,
    noYear: boolean = false,
    weekday: boolean = false,
    longMonth: boolean = false,
): string => {
    return new Date(date).toLocaleDateString('en-au', {
        weekday: weekday ? 'long' : undefined,
        year: noYear ? undefined : 'numeric',
        month: longMonth ? 'long' : 'short',
        day: noDay ? undefined : 'numeric',
    })
}

export const getShareSites = (currentUrl: string) => {
    return [
        {
            company: 'email',
            href: `mailto:?subject=Read this article on Benmax&body=${currentUrl}`,
        },
        {
            company: 'facebook',
            href: `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
        },
        {
            company: 'twitter',
            href: `https://twitter.com/intent/tweet?text=_&url=${decodeURIComponent(currentUrl)}`,
        },
        {
            company: 'linkedin',
            href: `https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}&amp;`,
        },
    ]
}

export const getVideoUrl = (videoFile: R2Asset, video: any): string | null => {
    if (videoFile) {
        return videoFile?.asset?.fileURL
    }

    if (video) {
        return video?.asset?.url
    }

    return null
}

export type R2Asset = {
    asset: {
        contentType: string
        fileURL: string
    }
}